(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Funzione', Funzione);

    Funzione.$inject = ['$resource'];

    function Funzione ($resource) {
        var resourceUrl =  'api/funziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
